const REPO_NAME = "profiles";
import { createTable, MapEntity } from "robodux";
import { ApiCtx, put, select } from "saga-query";

import { ThunkCtx } from "@app/state/apis/api";
import { IProfile, IProfileResponse } from "@app/types/insider";
/* --------------------------------- imports -------------------------------- */
import { createSelector } from "@reduxjs/toolkit";

import { inApi, inThunks } from "../apis/api";
/* ---------------------------------- types --------------------------------- */
import { RootState } from "../rootState";
import { select_api_login_amaid } from "./login";

export const processProfiles = (
  data: IProfileResponse[],
  thisAmaid: number
) => {
  return data.reduce<MapEntity<IProfile>>((acc, rec) => {
    acc[rec["AMA_ID"]] = {
      ...rec,
      AMAID: rec.AMA_ID,
      ACTIV: !!rec["ACTIV"],
      userIsMe: rec["AMA_ID"] === thisAmaid,
    };
    return acc;
  }, {});
};
/* ------------------------------- stor setup ------------------------------- */
export const repo = createTable<IProfile>({
  name: REPO_NAME,
});
/* --------------------------------- the api -------------------------------- */

export const getDbUsers = inApi.get(
  "/db/dbof_users",
  function* (ctx: ApiCtx<any, IProfileResponse>, next) {
    // yield* put(loaderActions.loa_users_load());
    yield* next();
    if (!ctx.json.ok) {
      return;
    }
    const { data } = yield ctx.json;
    const thisAmaid = yield* select(select_api_login_amaid);
    yield* put(repo.actions.set(processProfiles(data, thisAmaid)));
    // yield* put(loaderActions.loa_users_done());
  }
);

export const cleanupProfiles = inThunks.create(
  "cleanupProfiles",
  function* (ctx: ThunkCtx, next) {
    yield* put(repo.actions.reset());
    yield* next();
  }
);

/* -------------------------------- SELECTORS ------------------------------- */
const selectors = repo.getSelectors((state: RootState) => state[REPO_NAME]);

export const getUserList = (state: RootState) => {
  return state[REPO_NAME];
};

export const select_apiProf_usersRaw = createSelector(
  [selectors.selectTable],
  (profiles) => {
    return profiles;
  }
);

export const select_apiProf_usersAZ = createSelector([getUserList], (users) => {
  return (Object.values(users) as IProfile[]).sort((a, b) =>
    a["PRENUME_NUME"].localeCompare(b["PRENUME_NUME"])
  );
});

export const select_apiProf_usersCustomOrdered = createSelector(
  [getUserList],
  (users) => {
    return (Object.values(users) as IProfile[]).sort(
      (a, b) => a["NR_ORDINE"] - b["NR_ORDINE"]
    );
  }
);
